<template>
  <el-header height="90">
    <div class="header-cont">
      <div class="header-cont-left flex flex-shrink-0">
        <div class="logo"
             @click="$router.push('/home')">
          <span class="logo_left">WoYou </span>
          <span class="logo_right">工资</span>
        </div>
      </div>

      <div class="header-cont-right flex align-items-center">
        <!-- 广告位 -->
        <a class="advertisement"
           :href="adDetails.blogroll"
           target="_blank"
           v-if="adDetails&&!adDetails.isStop">

          <img v-if="adDetails&&!adDetails.isStop"
               :src="adDetails.pcImgUrl"
               alt="">
        </a>

        <el-popover placement="bottom"
                    trigger="hover">
          <span :class="['spanStyle', { spanActive: active == 1 }]"
                @click="drawerAgreementVisible = true"
                @mouseenter="activeIcon(1)"
                @mouseleave="activeIcon(0)">服务及免责说明</span>
          <span :class="['spanStyle', { spanActive: active == 2 }]"
                @click="drawerStatementVisible = true"
                @mouseenter="activeIcon(2)"
                @mouseleave="activeIcon(0)">知识产权申明</span>
          <span :class="['spanStyle', { spanActive: active == 3 }]"
                @click="userAgreementVisible = true"
                @mouseenter="activeIcon(3)"
                @mouseleave="activeIcon(0)">用户协议</span>
          <span :class="['spanStyle', { spanActive: active == 4 }]"
                @click="enterpriseServiceVisible = true"
                @mouseenter="activeIcon(4)"
                @mouseleave="activeIcon(0)">企业服务协议</span>
          <span :class="['spanStyle', { spanActive: active == 5 }]"
                @click="dividendAgreementVisible = true"
                @mouseenter="activeIcon(5)"
                @mouseleave="activeIcon(0)">奖励协议</span>
          <span :class="['spanStyle', { spanActive: active == 6 }]"
                @click="drawermonstransVisible = true"
                @mouseenter="activeIcon(6)"
                @mouseleave="activeIcon(0)">隐私政策</span>
          <span class="top-label"
                slot="reference">规则/政策</span>
        </el-popover>
        <span class="top-label"
              style="margin-right: 28px"
              @click="dialogHelpVisible = true">帮助中心</span>
        <span class="top-label"
              style="margin-right: 39px"
              @click="noticeVisible = true"><i style="font-size: 20px; color: #fff"
             class="el-icon-bell"></i></span>
        <span>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <img v-if="myPicture"
                   :src="myPicture"
                   alt="" />
              <img v-else
                   src="~/assets/img/avatar.png"
                   alt="" />
              <span style="margin-left: 9px; color: #fff; margin-right: 40px"
                    v-if="userInfo">{{ userInfo.cname }}</span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-user"
                                command="information">用户信息</el-dropdown-item>
              <el-dropdown-item icon="el-icon-lock"
                                command="password">修改密码</el-dropdown-item>
              <el-dropdown-item icon="el-icon-document"
                                command="agreement">我的协议</el-dropdown-item>
              <el-dropdown-item icon="el-icon-data-line"
                                command="dividend"
                                v-if="$store.state.authenticationState === 2">统计/奖励</el-dropdown-item>
              <!-- <el-dropdown-item icon="el-icon-document" command="textMessage"
                >短信模板</el-dropdown-item
              > -->
              <el-dropdown-item icon="el-icon-switch-button"
                                command="logout">切换/退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <b class="el-icon-question" style="margin-left:20px;font-size:22px" @click="dialogHelpVisible=true" title="SOHO猎帮助">&nbsp;</b> -->
        </span>
      </div>
    </div>
    <el-dialog title="系统通知"
               :visible.sync="noticeVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="40%">
      <div class="home-top-right">
        <Note />
      </div>
    </el-dialog>

    <el-dialog title="修改密码"
               :show-close="false"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="350px">
      <el-form :model="form"
               :rules="rules"
               size="small"
               ref="form"
               label-width="70px"
               label-position="left"
               v-enterToNext="true">
        <el-form-item label="旧密码"
                      prop="oldPassWord">
          <el-input v-model="form.oldPassWord"
                    type="password"
                    show-password
                    placeholder="请输入旧密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码"
                      prop="password">
          <el-input v-model="form.passWord"
                    type="password"
                    show-password
                    placeholder="输入新密码"></el-input>
        </el-form-item>

        <el-form-item label-width="0px"
                      style="margin-bottom: 0; text-align: center">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary"
                     @click="changePassword('form')">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <Help :visible="dialogHelpVisible"
          @close="dialogHelpVisible = false"></Help>
    <harmlessAgreement :visible="drawerAgreementVisible"
                       @close="drawerAgreementVisible = false"></harmlessAgreement>
    <IntellectualPropertyStatement :visible="drawerStatementVisible"
                                   @close="drawerStatementVisible = false"></IntellectualPropertyStatement>
    <userAgreement :visible="userAgreementVisible"
                   @close="userAgreementVisible = false"></userAgreement>
    <dividendAgreement :visible="dividendAgreementVisible"
                       @close="dividendAgreementVisible = false"></dividendAgreement>
    <enterpriseService :visible="enterpriseServiceVisible"
                       @close="enterpriseServiceVisible = false"></enterpriseService>
    <proxyAgreement :visible="proxyAgreementVisible"
                    @close="proxyAgreementVisible = false"></proxyAgreement>
    <dividend :visible="dividendVisible"
              @close="dividendVisible = false"></dividend>

    <monstrans :visible="drawermonstransVisible"
               @close="drawermonstransVisible = false"></monstrans>

    <el-dialog :visible.sync="informationVisible"
               width="500px"
               class="information"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               @close="closeDig">
      <el-tabs v-model="activeName"
               @tab-click="handleClick">
        <el-tab-pane label="个人信息"
                     name="first">
          <el-form ref="myform"
                   :model="userInfo"
                   :rules="rules"
                   label-width="96px"
                   size="small"
                   v-enterToNext="true">
            <div style="padding: 20px; display: flex; justify-content: center">
              <el-upload class="avatar-uploader"
                         action=""
                         accept=".jpg,.png"
                         :show-file-list="false"
                         :http-request="uploadAvatar">
                <img :src="
                    userInfo && userInfo.selfImagePath
                      ? userInfo.selfImagePath
                      : require('../assets/img/avatar.png')
                  "
                     class="avatar" />
                <!-- <div class="hover-tip">上传头像</div> -->
              </el-upload>
            </div>

            <el-form-item label="登录账号"
                          prop="account">
              <el-input v-model="userInfo.account"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="姓名"
                          prop="cname">
              <el-input v-model="userInfo.cname"
                        maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码"
                          prop="identityCard">
              <el-input v-model="userInfo.identityCard"
                        maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="手机号码"
                          prop="tel">
              <el-input v-model="userInfo.tel"
                        disabled
                        maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="邮箱">
              <el-input v-model="userInfo.email"
                        maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="userInfo.remark"
                        maxlength="50"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="企业信息"
                     name="second"
                     v-if="form.companyName && !$store.state.isPersonage">
          <el-form ref="companyform"
                   :model="form"
                   :rules="rules"
                   label-width="135px"
                   size="small"
                   v-enterToNext="true">
            <el-form-item label="企业名称"
                          prop="companyName">
              <el-input v-model="form.companyName"
                        maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="企业简称"
                          prop="companyShortName">
              <el-input v-model="form.companyShortName"
                        maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="企业联系人"
                          prop="contactName">
              <el-input v-model="form.contactName"> </el-input>
            </el-form-item>
            <el-form-item label="手机号码"
                          prop="contactPhone">
              <el-input v-model="form.contactPhone"
                        maxlength="11"> </el-input>
            </el-form-item>
            <el-form-item label="企业所在地"
                          prop="address">
              <el-input v-model="form.address"> </el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码"
                          prop="creditCode">
              <el-input v-model="form.creditCode"> </el-input>
            </el-form-item>
            <el-form-item label="营业执照">
              <el-upload :class="{ 'hide-upload': isHideUpload }"
                         accept=".jpg,.png"
                         action=""
                         disabled
                         :limit="1"
                         list-type="picture-card"
                         :file-list="form.license"
                         :before-remove="removeLicense"
                         :http-request="uploadLicense">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="认证状态">
              <el-tag v-if="form.authenticationState == 0">未认证</el-tag>
              <el-tag v-if="form.authenticationState == 1">认证中</el-tag>
              <el-tag v-if="form.authenticationState == 2">已认证</el-tag>
              <el-tag v-if="form.authenticationState == 3">认证未通过</el-tag>
              <p v-if="
                  form.authenticationState == 0 || form.authenticationState == 3
                "
                 style="
                  text-decoration: underline;
                  cursor: pointer;
                  color: #409eff;
                  display: inline-block;
                  margin-left: 10px;
                "
                 @click="
                  $router.push('/certifiSelection'),
                    (informationVisible = false)
                ">
                前往认证
              </p>
              <!-- <p
                v-if="form.authenticationState == 2"
                style="
                  text-decoration: underline;
                  cursor: pointer;
                  color: #409eff;
                  display: inline-block;
                  margin-left: 10px;
                "
                @click="cancel"
              >
                取消认证
              </p> -->
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer"
            class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">关 闭</el-button> -->

        <el-button type="primary"
                   :loading="submitLoading"
                   v-if="
            activeName == 'first' ||
            (activeName == 'second' && form.authenticationState == 0)
          "
                   @click="save(1)">保 存</el-button>

        <!-- <el-button
          type="primary"
          :loading="submitLoading"
          @click="save(2)"
          v-if="activeName == 'second' && form.authenticationState != 1"
          >保存并申请认证</el-button
        > -->
      </span>
    </el-dialog>
    <el-dialog title="提示"
               :visible.sync="detailialogVisible"
               width="30%">
      <span>这是一段信息</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="detailialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-header>
</template>

<script>
import Nav from "./Nav.vue";
import Help from "./HelpDoc.vue";
import dividend from "./dividend.vue";
import harmlessAgreement from "./textProtocol/harmlessAgreement.vue";
import IntellectualPropertyStatement from "./textProtocol/IntellectualPropertyStatement.vue";
import monstrans from "./textProtocol/monstrans.vue";
import userAgreement from "./textProtocol/userAgreement.vue";
import dividendAgreement from "./textProtocol/dividendAgreement.vue";
import enterpriseService from "./textProtocol/enterpriseService.vue";
import proxyAgreement from "./textProtocol/proxyAgreement.vue";
import IDCard from "china-id-card";
import Note from "@/components/Note";
import { AdDetails } from "@/utils/mixin";

import store from "../store/index";
export default {
  components: {
    Nav,
    Help,
    harmlessAgreement,
    IntellectualPropertyStatement,
    monstrans,
    userAgreement,
    enterpriseService,
    dividendAgreement,
    dividend,
    Note,
    proxyAgreement
  },
  props: {
    // menuList: Array,
  },
  mixins: [AdDetails],
  data () {
    let validatePhone = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号不正确"));
      } else {
        callback();
      }
    };
    let validateIdcard = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码

      if (!value) {
        callback();
      }
      if (IDCard(value).isVerified != true) {
        callback(new Error("身份证号码不正确"));
      } else {
        callback();
      }
    };
    let validatecreditCode = (rule, value, callback) => {
      //使用正则表达式进行统一社会信用代码
      if (!value) {
        callback();
      }
      if (
        !/^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/.test(
          value
        )
      ) {
        callback(new Error("统一社会信用代码不正确"));
      } else {
        callback();
      }
    };
    return {
      submitLoading: false,
      activeName: "first",
      active: "",
      informationVisible: false,
      dialogHelpVisible: false,
      myPicture: "",
      dividendVisible: false,
      drawerAgreementVisible: false,
      userAgreementVisible: false,
      dividendAgreementVisible: false,
      enterpriseServiceVisible: false,
      proxyAgreementVisible: false,
      drawerStatementVisible: false,
      drawermonstransVisible: false,
      detailialogVisible: false,
      noteList: [{ title: "版本说明", time: "2023-8-11", tip: "未读" }],
      noticeVisible: false,
      isHideUpload: false,
      advertiDetail: {},
      MessageCenterVisible: false,
      msgCount: 0,
      adDetails: '',
      dialogVisible: false,
      userInfo: { selfImagePath: "" },
      form: { license: [] },
      rules: {
        oldPassWord: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
        ],
        passWord: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { required: true, message: "密码最少6位字符", min: 6 },
        ],
        account: [
          { required: true, message: "请输入登录账号", trigger: "blur" },
        ],
        identityCard: [
          { required: true, message: "请输入身份证", trigger: "blur" },
          { validator: validateIdcard, trigger: "blur" },
        ],
        cname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        tel: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        contactName: [
          { required: true, message: "请输入企业联系人", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入企业手机号码", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        companyName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        companyShortName: [
          { required: true, message: "请输入企业简称", trigger: "blur" },
        ],
        creditCode: [{ validator: validatecreditCode, trigger: "blur" }],
        address: [
          { required: true, message: "请选择企业所在地", trigger: "blur" },
        ],
      },
    };
  },
  created () {


    this.getUserInfo();
    this.CompanyDetail();
    this.getAdDetails('6dacb4a6-0b03-4154-9984-66d75bc0ac40', this, 'adDetails');
  },
  methods: {
    see () {
      this.detailialogVisible = true;

    },
    navMsg (index) {
      if (index == 1) {
        this.noteList = [{ title: "版本说明", time: "2023-8-11", tip: "未读" }];
      } else {
        this.noteList = [
          { title: "版本说明1", time: "2023-8-11", tip: "已读" },
          { title: "版本说明2", time: "2023-8-11", tip: "已读" },
          { title: "版本说明3", time: "2023-8-11", tip: "已读" },
          { title: "版本说明4", time: "2023-8-11", tip: "已读" },
        ];
      }
    },
    activeIcon (i) {
      this.active = i;
    },
    cancel () {
      this.$confirm("确认要取消认证吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let sendData = new FormData();
        sendData.append("id", this.form.id);
        this.$api.user.CompanyCancelAuthentication(sendData).then((res) => {
          if (res.code === 0) {
            this.CompanyDetail();
            this.$message.success("取消成功");
          }
        });
      });
    },
    CompanyDetail () {
      this.$api.user.CompanyDetail().then((res) => {
        if (res.code === 0) {
          this.form = res.data;
          window.localStorage.setItem(
            "CompanyDetail",
            JSON.stringify(res.data)
          );
          this.$store.commit("change", res.data);
          if (res.data.businessLicencePath) {
            this.isHideUpload = true;
            this.form.license = [{ url: res.data.businessLicencePath }];
          } else {
            this.form.license = [];
          }


        }
      });
    },
    save (falg) {
      this.$refs[
        this.activeName == "first" ? "myform" : "companyform"
      ].validate((valid) => {
        if (!valid) {
          this.$message.warning("填写信息有误，请检查表单");
          return;
        }
        if (this.activeName == "first") {
          this.submitLoading = true;
          let sendData = {
            account: this.userInfo.account,
            roleId: JSON.parse(localStorage.getItem("userInfo")).roleId,
            tel: this.userInfo.account,
            cname: this.userInfo.cname,
            email: this.userInfo.email,
            identityCard: this.userInfo.identityCard,
            remark: this.userInfo.remark,
            selfImagePath: this.userInfo.selfImagePath,
          };
          if (JSON.parse(localStorage.getItem("userInfo")).id) {
            sendData.id = JSON.parse(localStorage.getItem("userInfo")).id;
          }
          this.$api.user.CompanyManageUserEdit(sendData).then((res) => {
            this.submitLoading = false;
            if (res.error === false) {
              this.getUserInfo();
              this.$message.success("保存成功");
              this.informationVisible = false;

            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          if (!this.form.creditCode && falg == 2) {
            this.$message.error("请填写统一社会信用代码");
            return;
          }
          if (!this.form.license && falg == 2) {
            this.$message.error("请上传营业执照");
            return;
          }
          let sendData = {
            companyName: this.form.companyName,
            address: this.form.address,
            businessLicencePath: this.form.license
              ? this.form.license[0].url
              : "",
            contactName: this.form.contactName,
            contactPhone: this.form.contactPhone,
            creditCode: this.form.creditCode,
          };
          if (this.form.id) {
            sendData.id = this.form.id;
          }

          this.submitLoading = true;
          console.log(sendData);
          this.$api.user[
            falg == 1 ? "CompanyEditCompanyInfo" : "EditAndSubmit"
          ](sendData).then((res) => {
            this.submitLoading = false;
            if (res.error === false) {
              this.CompanyDetail();
              this.$message.success("保存成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    // 认证
    sendAuthentication () { },
    push () {
      this.$router.push("/demo");
    },
    getMsgCount (count) {
      this.msgCount = count;
    },
    goauthentication () {
      this.informationVisible = true;
      this.activeName = "second";
    },
    changePassword (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.$message.warning("填写信息有误，请检查表单");
          return;
        }
        let sendData = {
          ids: [this.userInfo.id],
          oldPassWord: this.form.oldPassWord,
          passWord: this.form.passWord,
          checkPassWord: this.form.passWord,
        };
        this.$api.user.UpdatePassword(sendData).then((res) => {
          if (res.code === 0) {
            this.$message({
              type: "success",
              message: "密码修改成功，需重新登录，3秒后将跳转到登录页",
              duration: 3000,
            });
            setTimeout(() => {
              this.logout();
            }, 3000);
          } else {
            this.$message.error(res.msg);
          }
          this.dialogVisible = false;
          this.$refs[formName].resetFields();
        });
      });
    },
    uploadLicense (fileObj) {
      // const formData = new FormData();
      // formData.append("file", fileObj.file);
      this.$api.upload
        .uploadSingleImage(fileObj.file)
        .then((res) => {
          if (res.code === 0 && res.data[0]) {
            this.isHideUpload = true;
            console.log(res.data[0]);
            console.log(this.form.license);
            let img = { name: "", url: res.data[0] };
            this.form.license.push(img);
            this.$forceUpdate();
          }
        })
        .catch((error) => {
          this.submitLoading = false;
          if (error.response?.status == 400) {
            this.$message.warning("请上传jpg、png格式的图片");
            this.form.license = [];
          }
        });
    },
    handleClick () {
      this.$refs.myform.clearValidate();
      this.$refs.companyform.clearValidate();
    },
    removeLicense () {
      this.form.license.splice(0, 1);
      this.isHideUpload = false;
      console.log(this.form);
    },
    logout () {
      var lirm = localStorage.getItem("lirm");
      var lap = localStorage.getItem("lap");
      window.localStorage.clear();
      window.sessionStorage.clear();

      //如果记住密码，则留存
      if (lirm == 1) {
        localStorage.setItem("lap", lap);
      }
      this.$router.replace({ path: "/loginform", query: { type: "log" } });
      store.state.tabList = [];
    },
    handleCommand (command) {
      switch (command) {
        case "logout":
          this.logout();
          break;
        case "password":
          this.dialogVisible = true;
          break;
        case "information":
          this.informationVisible = true;
          break;
        case "dividend":
          // this.dividendVisible = true;
          this.$router.push("/dividend");
          break;
        case "agreement":
          this.proxyAgreementVisible = true;
          break;

        case "textMessage":
          this.$router.push("/textMessage");
      }
    },
    closeDig () {
      // this.form = { license: [] };
      this.$refs.myform.clearValidate();
      if (this.$refs.companyform) {
        this.$refs.companyform.clearValidate();
      }
    },
    uploadAvatar (fileObj) {
      if (fileObj.file.size > 1024 * 1024 * 10) {
        this.$message.warning(
          "文件不符合规则（图片大小不超过 10M），请重新上传~"
        );
        return;
      }
      this.$api.upload
        .uploadSingleImage(fileObj.file)
        .then((res) => {
          if (res.code === 0) {
            this.userInfo.selfImagePath = res.data[0];
          }
        })
        .catch((error) => {
          this.submitLoading = false;
          if (error.response?.status == 400) {
            this.$message.warning("请上传jpg、png格式的图片");
            this.userInfo.selfImagePath = "";
          }
        });
    },
    getUserInfo () {
      this.$api.user.GetCompanyManageUserInfo().then((res) => {
        if (res.code === 0) {
          this.userInfo = res.data;
          this.myPicture = res.data.selfImagePath;
          window.localStorage.setItem(
            "userInfo",
            JSON.stringify(this.userInfo)
          );
        }
      });
    },
    showSchedule () {
      this.$bus.$emit("showSchedule");
    },
  },
  watch: {
    informationVisible (newVal) {
      if (newVal) {
        this.activeName = "first";
        this.getUserInfo();
        this.CompanyDetail();
      }
    },
  },
};
</script>

<style lang="less">
.advertisement {
  width: 350px;
  height: 30px;
  margin-right: 50px;
  img {
    width: 100%;
    height: 100%;
  }
}
.msg-top {
  width: 100%;
  text-align: center;
  .msg-title {
    display: block;
    font-size: 16px;
    margin: 8px 0;
  }
  .msg-tab {
    .all {
      margin-left: 70px;
    }
  }
}

.spanStyle {
  margin-right: 15px;
  cursor: pointer;
}
.spanStyle:last-of-type {
  margin-right: 0;
}
.spanActive {
  color: #048cf8;
}
.el-header {
  background-color: #fff;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // border-bottom: 1px solid #f5f7fa;
  .information {
    .el-input {
      width: 300px;
    }
  }
  .hide-upload {
    .el-upload--picture-card {
      display: none;
    }
  }
  .avatar-uploader {
    img {
      width: 55px;
      height: 55px;
      border-radius: 10px;
    }
    // .hover-tip {
    //   width: ;
    //   width: 100%;
    //   height: 100%;
    //   border-radius: 50%;
    //   background-color: rgba(0, 0, 0, 0.5);
    //   color: #fff;
    //   font-size: 12px;
    //   line-height: 52px;
    //   transition: all 0.3s;
    // }
    &:hover {
      .hover-tip {
        opacity: 1;
      }
    }
  }
  .header-cont {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-image: url(../assets/img/top-bg.png);
    background-color: #12ccce;
    background-repeat: no-repeat;
    // background-size: cover;
    box-shadow: 0px 10px 18px #76767645;
    z-index: 99;
    .header-cont-left {
      .logo {
        min-height: 64px;
        line-height: 64px;
        font-size: 26px;
        padding: 0 25px;
        margin-right: 28px;
        cursor: pointer;
        user-select: none;
        .logo_left {
          width: 94px;
          height: 20px;
          font-family: YouSheBiaoTiYuan;
          font-size: 30px;
          font-weight: normal;
          font-style: italic;
          font-stretch: normal;
          line-height: 16px;
          letter-spacing: -2px;
          color: #82caff;
        }
        .logo_right {
          width: 47px;
          height: 23px;
          font-family: AlimamaShuHeiTi;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 16px;
          letter-spacing: 1px;
          color: #feffff;
        }
      }
    }
    .header-cont-right {
      .el-dropdown-link {
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          width: 35px;
          height: 35px;
          border: 1px solid #ddd;
          border-radius: 50%;
        }
      }
      .top-label {
        color: #fff;
        margin-right: 15px;
        cursor: pointer;
      }
      > span {
        display: flex;
        align-items: center;
      }
      .message-icon {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
      .el-icon-info {
        margin-left: 8px;
      }
      .schedule-icon {
        width: 21px;
        height: 21px;
        cursor: pointer;
        margin-right: 22px;
      }

      .el-badge {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 25px;
        .clock {
          margin-right: 0;
          transform-origin: 50% 0%;
          animation: swing 2s infinite ease 1s;
        }
        .el-badge__content {
          line-height: 16px;
        }
      }
    }
  }
}
.msg-popover {
  max-height: 45vh;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 3px;
    background-color: #f5f5f5;
  }
  &::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: #f5f5f5;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: #ddd;
  }
}
.msg-box {
  .el-button {
    text-align: center;
    padding: 0;
    line-height: 26px;
    width: 100%;
    border-radius: 4px;
    border: 0;
    background-color: #a1a3a6;
    color: #fff !important;
    margin-bottom: 10px;
  }
  .msg-list {
    li {
      margin-top: -1px;
      padding: 10px 0;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      font-size: 13px;
      .type {
        background-color: #2570a1;
        color: #fff;
        padding: 1px 5px;
        border-radius: 3px;
        margin-right: 3px;
        font-size: 12px;
      }
      .msg-cont {
        padding: 2px 0;
      }
      .msg-bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        > span {
          background-color: #ef4136;
          padding: 1px 5px;
          color: #fff;
          border-radius: 3px;
          cursor: pointer;
        }
      }
      .unfold {
        position: absolute;
        top: -25px;
        right: 5px;
        cursor: pointer;
        font-size: 0;
        i {
          font-style: normal;
          font-size: 25px;
        }
      }
    }
  }
}
@keyframes swing {
  0% {
    transform: rotate(-15deg);
  }
  2% {
    transform: rotate(15deg);
  }
  4% {
    transform: rotate(-18deg);
  }
  6% {
    transform: rotate(18deg);
  }
  8% {
    transform: rotate(-22deg);
  }
  10% {
    transform: rotate(22deg);
  }
  12% {
    transform: rotate(-18deg);
  }
  14% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-12deg);
  }
  18% {
    transform: rotate(12deg);
  }
  20% {
    transform: rotate(0deg);
  }
}
</style>
